var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.952,
    height: 18,
    viewBox: "0 0 25.952 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "car-svgrepo-com_3_",
    "data-name": "car-svgrepo-com (3)",
    d: "M24.5,84.552A4.436,4.436,0,0,0,20.234,80H18.82L15.5,75.074l-.916.617L17.488,80H7.43l.817-1.384L7.3,78.058,6.147,80h-.43a4.436,4.436,0,0,0-4.262,4.548A2.3,2.3,0,0,0,2.3,88.987h.34a3.631,3.631,0,1,0,7.2,0H16.11a3.632,3.632,0,1,0,7.2,0h.339a2.3,2.3,0,0,0,.843-4.435ZM5.717,81.108H20.234A3.019,3.019,0,0,1,22.526,82.2H20.171v1.1h3a3.76,3.76,0,0,1,.22,1.089H2.565A3.315,3.315,0,0,1,5.717,81.108ZM6.24,91.969a2.527,2.527,0,1,1,2.527-2.527A2.53,2.53,0,0,1,6.24,91.969Zm13.472,0a2.527,2.527,0,1,1,2.527-2.527A2.53,2.53,0,0,1,19.712,91.969Zm3.942-4.086h-.662a3.631,3.631,0,0,0-6.559,0H9.519a3.63,3.63,0,0,0-6.558,0H2.3a1.194,1.194,0,0,1,0-2.388H23.654a1.194,1.194,0,0,1,0,2.388Z",
    transform: "translate(0 -75.074)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/brand.f599e062615b13bb54eb9df72fa63937.svg";
export { ForwardRef as ReactComponent };